/** Copyright (c) 2019 T. Rowe Price. All rights reserved. */

import './PreferencesCheckwriting.scss';

import React, { Fragment } from 'react';
import { connect } from 'react-redux';

import Content from 'services/Content';
import { linkBuilder, preferencesLinks } from 'services/Externals';
import { ReactComponent as PdfIcon } from 'assets/icons/pdf.svg';
import PreferencesCheckwritingTable from 'components/layouts/Preferences/Checkwriting/PreferencesCheckwritingTable';
import PreferencesBreadCrumbs from 'components/layouts/Preferences/PreferencesBreadCrumbs';
import PreferencesCol from 'components/layouts/Preferences/shared/PreferencesCol';
import PreferencesHeader from 'components/layouts/Preferences/PreferencesHeader';
import PreferencesRow from 'components/layouts/Preferences/shared/PreferencesRow';
import PreferencesSection from 'components/layouts/Preferences/shared/PreferencesSection';
import { getView } from 'state/view/ViewSelectors';

const DesktopCheckwriting = ({ view, backPath, isBackPath }) => (
  <Fragment>
    <PreferencesBreadCrumbs backPath={backPath} isBackPath={isBackPath} />
    <PreferencesHeader>
      <div className="preferences-checkwriting-header">Checkwriting</div>
    </PreferencesHeader>
    <PreferencesSection>
      <div className="preferences-checkwriting">
        <PreferencesRow>
          <PreferencesCol col={9}>
            <PreferencesCheckwritingTable />
          </PreferencesCol>
          <PreferencesCol col={3}>
            <div className="preferences-checkwriting-copy">
              <p className="preferences-checkwriting-copy-info">
                {Content.checkWritingInfo}
              </p>
              <div className="preferences-checkwriting-order-checks">
                Ordering New Checks
              </div>
              <p className="preferences-checkwriting-copy-info">
                {Content.checkWritingInfoExtended}
              </p>
              <a
                className="preferences-checkwriting-form"
                rel="noreferrer"
                href={linkBuilder(preferencesLinks.checkWritingLink, view)}
                target="_blank">
                <PdfIcon className="name-change-icon" />
                Mutual Fund Checkwriting Form
              </a>
            </div>
          </PreferencesCol>
        </PreferencesRow>
      </div>
    </PreferencesSection>
  </Fragment>
);

const MobileCheckwriting = ({ view }) => (
  <Fragment>
    <PreferencesHeader>
      <div className="preferences-checkwriting-header">Checkwriting</div>
    </PreferencesHeader>
    <div className="preferences-checkwriting">
      <PreferencesCheckwritingTable isMobile={true} />
      <div className="preferences-checkwriting-copy">
        <p className="preferences-checkwriting-copy-info">
          {Content.checkWritingInfo}
        </p>
        <div className="preferences-checkwriting-order-checks">
          Ordering New Checks
        </div>
        <p className="preferences-checkwriting-copy-info">
          {Content.checkWritingInfoExtended}
        </p>
        <a
          className="preferences-checkwriting-form"
          rel="noreferrer"
          href={linkBuilder(preferencesLinks.checkWritingLink, view)}
          target="_blank">
          <PdfIcon className="name-change-icon" />
          Mutual Fund Checkwriting Form
        </a>
      </div>
    </div>
  </Fragment>
);

const PreferencesCheckwriting = ({ view, router, backPath = '/profile' }) => {
  const isBackPath = router.location.pathname === backPath;

  return view.isDesktopLayout ? (
    <DesktopCheckwriting
      view={view}
      backPath={backPath}
      isBackpath={isBackPath}
    />
  ) : (
    <MobileCheckwriting view={view} />
  );
};

const mapStateToProps = (state) => ({
  view: getView(state),
  router: state.router
});

export default connect(mapStateToProps)(PreferencesCheckwriting);
